import React, { useEffect } from 'react';
import block from 'bem-cn';
import SVGInline from 'react-svg-inline';

import { useSelector } from 'react-redux';

import BackBlock from 'components/BackBlock';
import Spinner from 'components/Spinner';

import { paymentMethods } from 'features/payment/model/suAdminPayment/utils/data';
import useSuAdminPayment from 'features/payment/model/suAdminPayment/useSuAdminPayment';

import './SuAdminPayment.scss';
import PaymentFramePage from '../Paykassma/PaymentFramePage/PaymentFramePage';

const b = block('sy-admin-payment');
const SuAdminPayment = () => {
  const { locale } = useSelector(state => state.locale);
  const { paymentLink, amount } = useSelector(state => state.payment);

  const model = useSuAdminPayment();

  const paymentItems = paymentMethods.map((item) => {
    return (
      <div key={item.key} className={b('payment-item')} onClick={() => model.openMethod(item.value)}>
        <div className={b('payment-item__img')}>
          <SVGInline svg={item.img} className={b('image').toString()} />
        </div>
        <div className={b('payment-item__name')}>{item.name}</div>
      </div>
    )
  });

  useEffect(() => {
    return () => {
      model.closeMethod();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if(paymentLink && amount && model.activeMethod === 'paykassma') {
    return (<PaymentFramePage operation="deposit" amount={amount} paymentLink={paymentLink} />)
  }

  return (
    <div className={b()}>
      {/* <Spinner isLoading={actionProcessing} /> */}
      <div className={b('back-block')} onClick={model.closeMethod}>
        <BackBlock route={model.methodIsOpen ? '/paymentSuAdmin' : '-1'} />
        <div className={b('title')}>{locale.suDeposit}</div>
      </div>

      <div className={b('animation-container', { active: model.methodIsOpen })}>
        <div className={b('payment-methods', { active: model.methodIsOpen })}>
          <span className={b('payment-methods-title')}>{locale.choosePayment}</span>
          <div className={b('payment-methods-items')}>{paymentItems}</div>
        </div>
        <div className={b('active-payment-method', { active: model.methodIsOpen })}>
          {model.getActivePaymentMethod()}
        </div>
      </div>
    </div>
  )
}

export default SuAdminPayment